import { SearchForSuggestionsResultList } from 'aws-sdk/clients/location';

import { isSuggestionStreetAddress } from './isSuggestionStreetAddress';
import { suggestionResultToSelectOption } from './suggestionResultToSelectOption';

export function mapSuggestionResultsToSelectOptions(
  suggestions: SearchForSuggestionsResultList
) {
  return suggestions
    .filter(isSuggestionStreetAddress)
    .map(suggestionResultToSelectOption);
}
